import React from 'react';
import { IconCrop, IconDelete, IconRestore, IconMore } from '@bynder/icons';
import { Dropdown, Button } from '@bynder/design-system';
import { Translate } from '@bynder/localization';

type CropperKebabAction = 'CROP' | 'RESET_CROP' | 'CLEAR_IMAGE';

type CropperKebabProps = {
  actions: {
    for: CropperKebabAction;
    onClick: () => void;
  }[];
};

const noop = () => void 0;

const CropperKebabMenu = ({ actions }: CropperKebabProps) => {
  const applyAction = (action: CropperKebabAction) => {
    const actionToApply = actions.find(a => a.for === action);

    if (actionToApply) {
      return actionToApply.onClick;
    }

    return noop;
  };

  return (
    <Dropdown
      trigger={({ isOpen, onClick, ...triggerProps }) => {
        const onClickDropdown = (e: React.SyntheticEvent) => {
          e.stopPropagation();
          onClick();
        };

        return (
          <Button
            isPressed={isOpen}
            aria-label="Theme set kebab menu"
            data-testid="themesetKebabMenu"
            variant="secondary"
            onClick={onClickDropdown}
            icon={<IconMore />}
            {...triggerProps}
          />
        );
      }}
    >
      {
        <>
          <Dropdown.Item
            onClick={applyAction('CROP')}
            icon={<IconCrop />}
            data-testid="cropPageHeaderImage"
          >
            <Translate id="CROPPER_KEBAB_MENU.CROP" />
          </Dropdown.Item>
          {actions.find(action => action.for === 'RESET_CROP') && (
            <Dropdown.Item
              icon={<IconRestore />}
              onClick={applyAction('RESET_CROP')}
              data-testid="cropResetPageHeaderImage"
            >
              <Translate id="CROPPER_KEBAB_MENU.RESET_CROP" />
            </Dropdown.Item>
          )}

          <Dropdown.Divider />
          <Dropdown.Item
            onClick={applyAction('CLEAR_IMAGE')}
            icon={<IconDelete />}
            data-testid="clearPageHeaderImage"
          >
            <Translate id="WIDGET_INSPECTOR.CLEAR_IMAGE_BUTTON" />
          </Dropdown.Item>
        </>
      }
    </Dropdown>
  );
};

export default CropperKebabMenu;
